/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum TransportMode {
  None = 0,
  Unknown = 1,
  Bus = 2,
  Water = 3,
  Bike = 4,
  Rail = 5,
  Air = 6,
  Tram = 7,
  Coach = 8,
  Metro = 9,
}
